import { catchError, EMPTY, Observable, of, switchMap, takeWhile } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { ServerProxyService } from "./server-proxy.service";

@Injectable({
  providedIn: 'root',
})

export class ImageService {

  private proxiesService = inject(ServerProxyService);

  public riderImage(sessionId: string, riderImageId: string): Observable<string> {
    if (!riderImageId || !sessionId) { return of(null); }
    return this.proxiesService.riderImage(sessionId, riderImageId);
  };

  getRiderImage(
    { hasNetwork$, sessionId, riderImageId }
    : { hasNetwork$: Observable<boolean>, sessionId: string, riderImageId: string },
  ): Observable<string> {
    return hasNetwork$.pipe(
      takeWhile(hasNetwork => !hasNetwork, true),
      switchMap(hasNetwork => hasNetwork ? this.riderImage(sessionId, riderImageId) : EMPTY),
      takeWhile(image => !image, true),
      catchError(err => {
        console.error(err);
        return of(null);
      }),
    );
  }
}
